import { twMerge } from 'tailwind-merge';
import { AvaturnAvatar } from './avatar.types';
import AvatarPlaceholder from './AvatarPlaceholder';

const AvatarImage = ({ userId, className, border, round, avaturnUser }: AvaturnAvatar) => {
  if (!avaturnUser.imageUrl) return <AvatarPlaceholder className={className} round={round} userId={userId} />;

  return (
    <div
      className={twMerge(
        'aspect-square w-full overflow-hidden',
        className,
        round && 'rounded-full bg-phenom-background-gradient object-cover',
      )}
    >
      <div className="flex h-full w-full items-start justify-center object-cover">
        <img
          src={avaturnUser.imageUrl}
          alt="Avatar"
          className={twMerge(`h-full w-full object-cover object-top`, round && 'rounded-full')}
          style={{
            transform: 'scale(2) translateY(-9%) translatex(2%)',
            transformOrigin: 'top center',
          }}
        />
      </div>
    </div>
  );
};

export default AvatarImage;
